"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    theme: 'dark',
    colors: {
        background: '#0F0F11',
        primary: '#F5F6F7',
        white: '#17171A',
        blue: {
            900: '#F2F3F5',
        },
        purple: {
            500: '#656DFD',
        },
        gray: {
            400: '#9CA3AF',
        },
        cyan: {
            500: '#00BDF2',
        },
        border: 'rgba(255, 255, 255, 0.08)',
    },
};
